import * as Yup from "yup";

const clienteValidator = Yup.object().shape({
  indicadorConsumidorFinal: Yup.boolean().required("Consumidor Final"),
  tipoContribuinteId: Yup.number().required("Tipo Contribuinte"),
  tabelaPrecoPadrao: Yup.number().nullable(),
  mensagemVenda: Yup.string().nullable(),
  limiteCompra: Yup.number().nullable(),
  grupoPessoaId: Yup.number().nullable(),
  sugestaoVendedorId: Yup.number().nullable(),
  meiosPagamento: Yup.array().nullable(),
  dependentes: Yup.array()
    .of(
      Yup.object().shape({
        nome: Yup.string().required("Nome do dependente"),
        dataNascimentoDependente: Yup.date()
          .typeError("Data de nascimento do dependente inválida")
          .max(
            new Date(),
            "Data de nascimento do dependente não pode ser futura",
          )
          .required("Data de nascimento do dependente"),
        celularDependente: Yup.string()
          .required("Celular do dependente")
          .test(
            "celularValido",
            "Celular do dependente inválido",
            (value) => !value || value.length === 11,
          ),
        emailDependente: Yup.string()
          .email("E-mail do dependente inválido")
          .nullable(),
      }),
    )
    .nullable(),
  tipoCompraGovernamental: Yup.string().when("orgaoGovernamental", {
    is: true,
    then: Yup.string().nullable().required("Tipo de Compra Governamental"),
    otherwise: Yup.string().nullable(),
  }),
  percentualReducaoIbs: Yup.number().when("orgaoGovernamental", {
    is: true,
    then: Yup.number()
      .nullable()
      .required("Percentual de Redução das Alíquotas IBS/CBS"),
    otherwise: Yup.number().nullable(),
  }),
  tipoOperacaoGovernamental: Yup.string().when("orgaoGovernamental", {
    is: true,
    then: Yup.string().nullable().required("Tipo de Operação Governamental"),
    otherwise: Yup.string().nullable(),
  }),
});

export default clienteValidator;
